<template>
  <div class="div-bg">
    <div
      class="loading"
      v-show="is_loading"
    >
      <img
        :src="require('../assets/loading.gif')"
        class="loadimg"
      >
    </div>
    <!--物流跟踪-->
    <div style="padding-bottom: 0.5rem;">
      <!-- <div v-show="logisticsList.length<1" style="margin-bottom: 35px;margin-left:140px;"><img :src="require('../assets/trackIndex.png')" alt=""></div> -->
      <div
        v-show="logisticsList.length>0"
        style="width: 75%; margin: 10px 4% 0 0;padding-left: 15px;padding-right: 15px;float:left;"
      >
        <div style="margin-bottom:35px;">
          <div
            class="btn-group btn-group-lg"
            role="group"
            aria-label="Basic example"
            style="float:right;"
          >
            <button
              type="button"
              class="btn btn-light btn-lg"
              @click="dataAllProcessing()"
              data-toggle="tooltip"
              data-placement="top"
              title="复制所有单号的详细轨迹"
            >复制全部</button>
            <button
              type="button"
              class="btn btn-light btn-lg"
              @click="dataNewProcessing()"
              data-toggle="tooltip"
              data-placement="top"
              title="复制所有单号的最新轨迹"
            >复制最新</button>
          </div>
        </div>
        <div
          v-for="(item1,index1) in logisticsList"
          :key="index1"
          class="tracklist-item tracklist-tracking"
        >
          <div
            @click="changeContent(index1)"
            class="tracklist-header"
            style="padding: 10px;"
          >
            <div
              class="yqcr-ps"
              style="float: left"
            >
              <img
                width="40"
                :src="item1.status_img"
                style="float: left"
              >
              <div
                data-name=""
                style="float: left"
              >
                <p
                  class="text-uppercase"
                  style="margin: 0;text-align: left;margin-left:3px;"
                  :title="item1.trackingNumber"
                >{{item1.trackingNumber}}</p>
                <p
                  class="text-capitalize"
                  style="margin:0;text-align: left;margin-left:3px;"
                  :title="item1.sign_tip"
                >{{item1.sign_tip}}</p>
              </div>
            </div>
            <div
              class="yqcr-transit-mid jaTour2"
              style="margin-left: 30px"
            >
              <span style="text-align: right;line-height: 40px;">目的国：</span>
              <span style="text-align: left;line-height: 40px;">{{item1.consigneeCountry}}</span>
            </div>
            <div
              class="box"
              style="margin-left: 20px;text-align: left;vertical-align:middle;height:40px;"
            >
              <span
                class="wrap"
                style="line-height: 20px;"
              >{{item1.trackDate}} {{item1.trackLocation==""?"":item1.trackLocation+","}}{{item1.trackContent}}</span>
            </div>
          </div>
          <div
            class="track-rcol"
            v-if="item1.showContent"
          >
            <div class="track-list">
              <ul>
                <div>
                  <div
                    v-for="(item,index) in item1.lists"
                    :key="index"
                  >
                    <li
                      class="first"
                      v-if="index===0"
                    >
                      <div></div>
                      <i class="node-icon"></i>
                      <span
                        class="txt"
                        style="font-weight: bolder"
                      >{{item.track_date}}<span style="margin-right:18px;"></span>{{item.track_location==""?"":item.track_location+","}}{{item.track_content}}</span>
                    </li>
                    <li v-if="index > 0 && index !== item1.length-1">
                      <i class="node-icon"></i>
                      <span class="txt">{{item.track_date}}<span style="margin-right:18px;"></span>{{item.track_location==""?"":item.track_location+","}}{{item.track_content}}</span>
                    </li>
                    <li
                      v-if="index === item1.length-1"
                      class="finall"
                    >
                      <i class="div-spilander"></i>
                      <i class="node-icon"></i>
                      <span class="txt">{{item.track_date}}<span style="margin-right:18px;"></span>{{item.track_location==""?"":item.track_location+","}}{{item.track_content}}</span>
                    </li>
                  </div>
                </div>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div :style="logisticsList.length>0?{float: 'left',margin: 'auto 0'}:{margin:'220px 0 0 0'}">
        <div
          contenteditable
          class="highlight needsclick"
          ref="order_input"
          id="content"
          @focus="getFocus"
          @blur="getBlur"
          style="margin-top: 10px;"
          :class="logisticsList.length>0?'text-small':'text'"
          @input="changeVal"
        >
          请输入要查询的单号<br />一行一个,支持批量查询<br />Введите до 50 номеров, по одному в каждой строке.
        </div>
        <!-- <textarea v-model="message" placeholder="请输入要查询的单号"></textarea> -->
        <button
          @click="reset()"
          class="btn btn-danger"
          style="border-color: #47b5da;background-color: #47b5da;margin-right:15px; width:120px;height:40px;color:#f0f0f0;font-size:15px;"
        ><svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-trash"
            viewBox="0 0 16 16"
          >
            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
            <path
              fill-rule="evenodd"
              d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4L4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
            />
          </svg></button>
        <button
          @click="as()"
          class="btn btn-success"
          style="border-color: #0397bc;background-color: #0397bc;margin: 15px 0;width:140px;height:40px;color:#f0f0f0;font-size:15px;"
        ><svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-search"
            viewBox="0 0 16 16"
          >
            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
          </svg></button>
      </div>
    </div>
    <div class="div-bottom">
      <span class="span-bottom"> <a href="https://beian.miit.gov.cn" target="_blank" style="color:aliceblue">粤ICP备15108922号-2</a> </span>
    </div>
  </div>
</template>

<script>
// import qs from "Qs";
// import $ from 'jquery'

export default {
  name: "Logic",
  data() {
    return {
      logisticsList: [],
      message: "",
      inputText: "",
      countryCode: {
        AD: "安道尔",
        AE: "阿联酋",
        AF: "阿富汗",
        AG: "安提瓜",
        AI: "安圭拉",
        AL: "阿尔巴尼亚",
        AM: "亚美尼亚",
        AN: "荷属安的列斯群岛",
        AO: "安哥拉",
        AR: "阿根廷",
        AS: "美属萨摩亚群岛",
        AT: "奥地利",
        AU: "澳大利亚",
        AW: "阿鲁巴",
        AX: "奥兰群岛",
        AZ: "阿塞拜疆",
        BA: "波斯尼亚-黑塞哥维那共和国",
        BB: "巴巴多斯",
        BD: "孟加拉",
        BE: "比利时",
        BF: "布基纳法索",
        BG: "保加利亚",
        BH: "巴林",
        BI: "布隆迪",
        BJ: "贝宁",
        BM: "百慕大",
        BN: "文莱",
        BO: "玻利维亚",
        BR: "巴西",
        BS: "巴哈马",
        BT: "不丹",
        BV: "布维岛",
        BW: "博茨瓦纳",
        BY: "白俄罗斯",
        BZ: "伯利兹",
        CA: "加拿大",
        CC: "科科斯群岛",
        CD: "刚果民主共和国",
        CF: "中非共和国",
        CG: "刚果",
        CH: "瑞士",
        CI: "科特迪瓦(象牙海岸)",
        CK: "库克群岛",
        CL: "智利",
        CM: "喀麦隆",
        CN: "中国",
        CO: "哥伦比亚",
        CR: "哥斯达黎加",
        CS: "塞尔维亚和黑山",
        CU: "古巴",
        CV: "佛得角群岛",
        CX: "圣诞岛",
        CY: "塞浦路斯",
        CZ: "捷克共和国",
        DE: "德国",
        DJ: "吉布提",
        DK: "丹麦",
        DM: "多米尼加",
        DO: "多米尼加共和国",
        DZ: "阿尔及利亚",
        EC: "厄瓜多尔",
        EE: "爱沙尼亚",
        EG: "埃及",
        EH: "西撒哈拉",
        ER: "厄立特里亚",
        ES: "西班牙",
        ET: "埃塞俄比亚",
        FI: "芬兰",
        FJ: "斐济群岛",
        FK: "福克兰群岛",
        FM: "密克罗尼西亚",
        FO: "法罗群岛",
        FR: "法国",
        FX: "法属美特罗波利坦",
        GA: "加蓬",
        GB: "英国",
        GD: "格林纳达",
        GE: "格鲁吉亚",
        GF: "法属圭亚那",
        GG: "根西岛",
        GH: "加纳",
        GI: "直布罗陀",
        GL: "格陵兰岛",
        GM: "冈比亚",
        GN: "几内亚",
        GP: "瓜德罗普",
        GQ: "赤道几内亚",
        GR: "希腊",
        GS: "南乔治亚岛和南桑威奇群岛",
        GT: "危地马拉",
        GU: "关岛",
        GW: "几内亚比绍",
        GY: "圭亚那",
        HK: "中国香港",
        HM: "赫德岛和麦克唐纳岛",
        HN: "洪都拉斯",
        HR: "克罗地亚",
        HT: "海地",
        HU: "匈牙利",
        IC: "加那利群岛",
        ID: "印度尼西亚",
        IE: "爱尔兰",
        IL: "以色列",
        IN: "印度",
        IO: "英属印度洋地区(查各群岛)",
        IQ: "伊拉克",
        IR: "伊朗",
        IS: "冰岛",
        IT: "意大利",
        JE: "泽西岛",
        JM: "牙买加",
        JO: "约旦",
        JP: "日本",
        JU: "南斯拉夫",
        KE: "肯尼亚",
        KG: "吉尔吉斯斯坦",
        KH: "柬埔寨",
        KI: "基里巴斯",
        KM: "科摩罗",
        KN: "圣基茨",
        KP: "朝鲜",
        KR: "韩国",
        KV: "科索沃",
        KW: "科威特",
        KY: "开曼群岛",
        KZ: "哈萨克斯坦",
        LA: "老挝",
        LB: "黎巴嫩",
        LC: "圣卢西亚岛",
        LI: "列支敦士登",
        LK: "斯里兰卡",
        LR: "利比里亚",
        LS: "莱索托",
        LT: "立陶宛",
        LU: "卢森堡",
        LV: "拉脱维亚",
        LY: "利比亚",
        MA: "摩洛哥",
        MC: "摩纳哥",
        MD: "摩尔多瓦",
        ME: "黑山共和国",
        MG: "马达加斯加",
        MH: "马绍尔群岛",
        MK: "马其顿",
        ML: "马里",
        MM: "缅甸",
        MN: "蒙古",
        MO: "澳门",
        MP: "塞班岛",
        MQ: "马提尼克岛",
        MR: "毛里塔尼亚",
        MS: "蒙特塞拉岛",
        MT: "马耳他",
        MU: "毛里求斯",
        MV: "马尔代夫",
        MW: "马拉维",
        MX: "墨西哥",
        MY: "马来西亚",
        MZ: "莫桑比克",
        NA: "纳米比亚",
        NC: "新喀里多尼亚",
        NE: "尼日尔",
        NF: "诺福克岛",
        NG: "尼日利亚",
        NI: "尼加拉瓜",
        NL: "荷兰",
        NO: "挪威",
        NP: "尼泊尔",
        NR: "瑙鲁",
        NU: "纽埃岛",
        NZ: "新西兰",
        OM: "阿曼",
        PA: "巴拿马",
        PE: "秘鲁",
        PF: "法属波利尼西亚",
        PG: "巴布亚新几内亚",
        PH: "菲律宾",
        PK: "巴基斯坦",
        PL: "波兰",
        PM: "圣皮埃尔和密克隆群岛",
        PN: "皮特凯恩群岛",
        PR: "波多黎各",
        PS: "巴勒斯坦",
        PT: "葡萄牙",
        PW: "帕劳",
        PY: "巴拉圭",
        QA: "卡塔尔",
        RE: "留尼汪岛",
        RO: "罗马尼亚",
        RS: "塞尔维亚共和国",
        RU: "俄罗斯",
        RW: "卢旺达",
        SA: "沙特阿拉伯",
        SB: "所罗门群岛",
        SC: "塞舌尔",
        SD: "苏丹",
        SE: "瑞典",
        SG: "新加坡",
        SH: "圣赫勒拿岛",
        SI: "斯洛文尼亚",
        SJ: "斯瓦尔巴岛和扬马延岛",
        SK: "斯洛伐克",
        SL: "塞拉利昂",
        SM: "圣马力诺",
        SN: "塞内加尔",
        SO: "索马里兰",
        SR: "苏里南",
        SS: "南苏丹共和国",
        ST: "圣多美和普林西比",
        SV: "萨尔瓦多",
        SY: "叙利亚",
        SZ: "斯威士兰",
        TA: "特里斯坦",
        TC: "特克斯和凯科斯群岛",
        TD: "乍得",
        TF: "法属南部领土",
        TG: "多哥",
        TH: "泰国",
        TJ: "塔吉克斯坦",
        TK: "托克劳",
        TL: "东帝汶",
        TM: "土库曼斯坦",
        TN: "突尼斯",
        TO: "汤加",
        TR: "土耳其",
        TT: "特立尼达和多巴哥",
        TV: "图瓦卢",
        TW: "中国台湾",
        TZ: "坦桑尼亚",
        UA: "乌克兰",
        UG: "乌干达",
        UM: "美国本土外小岛屿",
        US: "美国",
        UY: "乌拉圭",
        UZ: "乌兹别克斯坦",
        VA: "梵蒂冈",
        VC: "圣文森特岛",
        VE: "委内瑞拉",
        VG: "英属维尔京群岛",
        VI: "美属维尔京群岛",
        VN: "越南",
        VU: "瓦努阿图",
        WF: "瓦利斯群岛和富图纳群岛",
        WS: "西萨摩亚",
        XB: "伯奈尔岛",
        XC: "库拉索岛(荷兰)",
        XD: "阿森松",
        XE: "圣尤斯塔提马斯岛",
        XG: "北非西班牙属土",
        XH: "亚速尔群岛",
        XI: "马德拉岛",
        XJ: "巴利阿里群岛",
        XK: "加罗林群岛",
        XM: "圣马腾岛",
        XN: "尼维斯岛",
        XS: "索马里共和国",
        XY: "圣巴特勒米岛",
        YE: "也门",
        YT: "马约特",
        ZA: "南非",
        ZM: "赞比亚",
        ZR: "扎伊尔",
        ZW: "津巴布韦",
      },
      alert: true,
      is_loading: false,
      inner_text:
        "请输入要查询的单号<br/>一行一个,支持批量查询<br/>Введите до 50 номеров, по одному в каждой строке.",
      need_copy: "",
    };
  },
  created() {
    this.$nextTick(() => {
      this.getSearch();
    });
  },
  methods: {
    getSearch() {
      let that = this;
      let order_number = that.getQueryString("order_number");
      if (order_number) {
        that.message = order_number;
        this.$refs.order_input.innerText = order_number;
        that.as();
      }
    },
    getQueryString(name) {
      let reg = `(^|&)${name}=([^&]*)(&|$)`;
      let r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    getFocus(ref) {
      console.log(this.message);
      if (this.Trim(this.message, "g").split("\n") == "") {
        ref.target.innerText = "";
        // this.placeholderText = '';
      }
    },

    getBlur(ref) {
      if (ref.target.innerText == "") {
        ref.target.innerText =
          "请输入要查询的单号\n一行一个,支持批量查询\nВведите до 50 номеров, по одному в каждой строке.";
      }
    },
    changeVal(ref) {
      this.message = ref.target.innerText;
      console.log("this.inputText==>", this.message);
    },
    reset() {
      this.message = "";
      this.$refs.order_input.innerText = "";
    },
    changeContent(index) {
      console.log(this.logisticsList);
      this.$set(
        this.logisticsList[index],
        "showContent",
        !this.logisticsList[index].showContent
      );
    },

    as() {
      let codes = this.Trim(this.message, "g").split("\n");
      this.logisticsList = [];
      console.log(codes);
      if (codes.length == 1 && codes[0] == "") {
        return;
      }

      for (let code in codes) {
        this.logisticsList.push({
          trackingNumber: codes[code],
          trackSignperson: "",
          businessStatus: "",
          trackContent: "",
          trackDate: "",
          productKindName: "",
          consigneeCountry: "",
          trackLocation: "",
          status_img: "",
          lists: "",
          showContent: false,
          sign_tip: "正在查询....",
        });
      }

      this.is_loading = true;
      let param = {
        documentCode: codes.join(","),
      };
      var qs = require("qs");
      this.axios.post("/a.php", qs.stringify(param)).then((res) => {
      // this.axios.post("/api/selectTrack.htm",qs.stringify(param)).then((res)=>{
        console.log(res);
        let track_datas = {};
        let customer_track_datas = {};
        let channel_track_datas = {};
        if (res.data[0].ack == "true") {
          for (let i in res.data[0].data) {
            let status_img;
            let sign_tip;
            switch (res.data[0].data[i].businessStatus) {
              case "签收": {
                status_img = require("../assets/signed.png");
                let trackDetails = res.data[0].data[i].trackDetails;
                let firstSignIndex = 0;

                for (let j in trackDetails) {
                  if (trackDetails[j].track_signdate != "") {
                    firstSignIndex = j;
                  }
                }
                console.log(firstSignIndex);

                sign_tip =
                  "成功签收(" +
                  this.getDataBetween(
                    trackDetails[trackDetails.length - 1].track_date,
                    trackDetails[firstSignIndex].track_date
                  ) +
                  "天)";
                break;
              }
              case "销毁":
              case "货物丢失":
              case "已赔付":
                status_img = require("../assets/danger.png");
                sign_tip = res.data[0].data[i].businessStatus;
                break;
              case "异常":
                status_img = require("../assets/exception.png");
                sign_tip = res.data[0].data[i].businessStatus;
                break;
              case "退件":
              case "退仓":
                status_img = require("../assets/error.png");
                sign_tip = res.data[0].data[i].businessStatus;
                break;
              case "退仓上架":
                status_img = require("../assets/warehouse.png");
                sign_tip = res.data[0].data[i].businessStatus;
                break;
              case "到达待取":
                status_img = require("../assets/pickup.png");
                sign_tip = res.data[0].data[i].businessStatus;
                break;
              default:
                status_img = require("../assets/unsigned.png");
                sign_tip = res.data[0].data[i].businessStatus;
                break;
            }

            for (let i2 in res.data[0].data[i].trackDetails) {
              res.data[0].data[i].trackDetails[
                i2
              ].track_content = this.trimQuestion(
                res.data[0].data[i].trackDetails[i2].track_content
              );
            }

            track_datas[res.data[0].data[i].trackingNumber] = {
              trackingNumber: res.data[0].data[i].trackingNumber,
              trackSignperson: res.data[0].data[i].trackSignperson,
              businessStatus: res.data[0].data[i].businessStatus,
              trackContent: this.trimQuestion(res.data[0].data[i].trackContent),
              trackDate: res.data[0].data[i].trackDate,
              productKindName: res.data[0].data[i].productKindName,
              consigneeCountry: this.countryCode[
                res.data[0].data[i].consigneeCountry
              ],
              trackLocation: res.data[0].data[i].trackLocation,
              status_img: status_img,
              lists: res.data[0].data[i].trackDetails,
              showContent: false,
              sign_tip: sign_tip,
            };

            customer_track_datas[res.data[0].data[i].referenceNumber] = {
              trackingNumber: res.data[0].data[i].referenceNumber,
              trackSignperson: res.data[0].data[i].trackSignperson,
              businessStatus: res.data[0].data[i].businessStatus,
              trackContent: res.data[0].data[i].trackContent,
              trackDate: res.data[0].data[i].trackDate,
              productKindName: res.data[0].data[i].productKindName,
              consigneeCountry: this.countryCode[
                res.data[0].data[i].consigneeCountry
              ],
              trackLocation: res.data[0].data[i].trackLocation,
              status_img: status_img,
              lists: res.data[0].data[i].trackDetails,
              showContent: false,
              sign_tip: sign_tip,
            };

            channel_track_datas[res.data[0].data[i].business_seqinvoicecode] = {
              trackingNumber: res.data[0].data[i].business_seqinvoicecode,
              trackSignperson: res.data[0].data[i].trackSignperson,
              businessStatus: res.data[0].data[i].businessStatus,
              trackContent: res.data[0].data[i].trackContent,
              trackDate: res.data[0].data[i].trackDate,
              productKindName: res.data[0].data[i].productKindName,
              consigneeCountry: this.countryCode[
                res.data[0].data[i].consigneeCountry
              ],
              trackLocation: res.data[0].data[i].trackLocation,
              status_img: status_img,
              lists: res.data[0].data[i].trackDetails,
              showContent: false,
              sign_tip: sign_tip,
            };

            // this.logisticsList.push({
            //     trackingNumber: res.data[0].data[i].trackingNumber,
            //     trackSignperson: res.data[0].data[i].trackSignperson,
            //     businessStatus: res.data[0].data[i].businessStatus,
            //     trackContent: res.data[0].data[i].trackContent,
            //     trackDate: res.data[0].data[i].trackDate,
            //     productKindName: res.data[0].data[i].productKindName,
            //     consigneeCountry: this.countryCode[res.data[0].data[i].consigneeCountry],
            //     trackLocation: res.data[0].data[i].trackLocation,
            //     status_img: status_img,
            //     lists: res.data[0].data[i].trackDetails,
            //     showContent: false,
            //     sign_tip:sign_tip
            //   })
          }
          // console.log(this.countryCode)
          // console.log(this.logisticsList)
        }

        for (let logistic in this.logisticsList) {
          let trackingNumber = this.logisticsList[logistic].trackingNumber;
          //先查看转单号是否对应，优先匹配转单号
          if (trackingNumber in track_datas) {
            this.$set(
              this.logisticsList,
              logistic,
              track_datas[trackingNumber]
            );
          } else {
            //再查看客户单号是否对应
            if (trackingNumber in customer_track_datas) {
              this.$set(
                this.logisticsList,
                logistic,
                customer_track_datas[trackingNumber]
              );
            } else {
              //最后查看渠道转单号，序列号(暂时搁置)
              if (trackingNumber in channel_track_datas) {
                this.$set(
                  this.logisticsList,
                  logistic,
                  channel_track_datas[trackingNumber]
                );
              } else {
                this.$set(
                  this.logisticsList[logistic],
                  "status_img",
                  require("../assets/noutfound.png")
                );
                this.$set(
                  this.logisticsList[logistic],
                  "trackContent",
                  "该包裹尚未入库"
                );
                this.$set(this.logisticsList[logistic], "trackLocation", "");
                this.$set(this.logisticsList[logistic], "sign_tip", "暂无轨迹");
                this.$set(this.logisticsList[logistic], "showContent", false);
              }
            }
          }
        }
        console.log(this.logisticsList);

        this.is_loading = false;
      });
    },
    getDataBetween(time1, time2) {
      var startDate = new Date(new Date(time1).toLocaleDateString()).getTime();
      var endDate = new Date(new Date(time2).toLocaleDateString()).getTime();
      var days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      // alert(days);
      return days;
    },
    Trim(str, is_global) {
      var result;
      // eslint-disable-next-line no-useless-escape
      result = str.replace(/(^[^\w\[\]]+|[^\w\[\]]+$)/g, "");
      result = result.replace(/\n{2,}/g, "\n");
      console.log(result);
      if (is_global.toLowerCase() == "g") {
        // eslint-disable-next-line no-useless-escape
        result = result.replace(/[^\w\n\r\[\]]/g, "");
      }
      // console.log(result)

      return result;
    },
    trimOrder: (str) => {
      return str.replace(/\n{1,}/g, ",");
    },
    trimQuestion: (str) => {
      return str.replace(/\?{1,}/g, " ");
    },
    dataNewProcessing: function () {
      this.need_copy = "";
      for (let i in this.logisticsList) {
        let trackingNumber = this.logisticsList[i].trackingNumber;
        let consigneeCountry = this.logisticsList[i].consigneeCountry;
        let trackDate = this.logisticsList[i].trackDate;
        let trackLocation = this.logisticsList[i].trackLocation;
        let trackContent = this.logisticsList[i].trackContent;
        let sign_tip = this.logisticsList[i].sign_tip;
        this.need_copy +=
          trackingNumber +
          "\t" +
          consigneeCountry +
          "\t" +
          trackDate +
          ", " +
          (trackLocation == ""
            ? trackContent
            : trackLocation + "," + trackContent) +
          "\t" +
          sign_tip +
          "\n";
      }
      this.doCopy();
    },
    dataAllProcessing: function () {
      this.need_copy = "";
      for (let i in this.logisticsList) {
        let trackingNumber = this.logisticsList[i].trackingNumber;
        let consigneeCountry = this.logisticsList[i].consigneeCountry;
        let sign_tip = this.logisticsList[i].sign_tip;
        let tracking_list = this.logisticsList[i].lists;
        this.need_copy += this.assign_text(
          trackingNumber,
          sign_tip,
          consigneeCountry,
          tracking_list
        );
      }
      this.doCopy();
    },
    assign_text: function (
      trackingNumber,
      sign_tip,
      consigneeCountry,
      tracking_list
    ) {
      let re_text =
        "单号：" +
        trackingNumber +
        "\n" +
        "包裹状态：" +
        sign_tip +
        "\n" +
        "目的国：" +
        consigneeCountry +
        "\n";
      for (let i in tracking_list) {
        let track_date = tracking_list[i]["track_date"];
        let track_location = tracking_list[i]["track_location"];
        let track_content = tracking_list[i]["track_content"];
        re_text +=
          track_date +
          ", " +
          (track_location == "" ? "" : track_location + ",") +
          track_content +
          "\n";
      }
      re_text += "============================================\n";
      return re_text;
    },
    doCopy: function () {
      this.$copyText(this.need_copy).then(
        function (e) {
          alert("复制成功！");
          console.log(e);
        },
        function (e) {
          alert("复制失败，请联系管理员或更换浏览器");
          console.log(e);
        }
      );
    },
  },

  /**
   * 加载时执行
   */
  mounted: function () {},
};
</script>
<style scoped>
.loading {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: #bbbbbb;
  opacity: 0.5;
  z-index: 998;
}

.div-bottom{
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 30px;
  z-index: 999;
  padding: 5px;
  box-sizing: border-box;
  text-align: center;
  /* 背景色随父元素 */
  background-color: inherit;
  color: #e0e0e0;
}

.loadimg {
  /* margin: auto auto; */
  background-color: red;
  position: fixed;
  top: 20%;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 999;
}
.box {
  width: 500px;
  height: 300px;
  /* border: 1px solid #FFF;  
      background-color: #999;   */
  display: table;
}
.wrap {
  display: table-cell;
  vertical-align: middle;
}

.text {
  width: 608px;
  height: 230px;
  min-height: r(160);
  max-height: r(200);
  font-size: small;
  text-align: justify;
  overflow-y: auto;
  outline: none;
  margin: 0 auto;
  margin-top: r(100);
  padding: 10px;
  color: #757575;
  /* -webkit-box-shadow: 0 0 8px 2px rgba(0,0,0,.12) inset;
      box-shadow: 0 0 8px 2px rgba(0,0,0,.12) inset; */
}

.text-small {
  width: 280px;
  height: 230px;
  min-height: r(160);
  max-height: r(200);
  font-size: small;
  text-align: justify;
  overflow-y: auto;
  outline: none;
  margin: 0 auto;
  margin-top: r(100);
  padding: 10px;
  color: #757575;
  /* -webkit-box-shadow: 0 0 8px 2px rgba(0,0,0,.12) inset;
      box-shadow: 0 0 8px 2px rgba(0,0,0,.12) inset; */
}
.highlight {
  padding: 9px 14px;
  margin-bottom: 14px;
  background-color: #f7f7f9;
  border: 2px solid #9e9e9e;
  border-radius: 2px;
}
.placeholderClass {
  color: #ccc;
}
.yqcr-last-event-pc {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  padding: 10px;
  cursor: pointer;
  -webkit-box-pack: left;
  -webkit-justify-content: left;
  -ms-flex-pack: left;
  justify-content: left;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.transfer {
  width: 36px;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAoCAYAAACWwljjAAAAAXNSR…TYrUAxeTTKnplgnwSKATLBooYTAQQQQAABBBBAAIGzwAYBUB18o8ZmbgAAAABJRU5ErkJggg==);
  background-repeat: no-repeat;
  background-position: center center;
}
.text-uppercase {
  text-transform: uppercase !important;
}
.text-capitalize {
  text-transform: capitalize !important;
}
.tracklist-item {
  position: relative;
  margin-bottom: 5px;
  background: #fff;
  /* border: 1px solid rgb(117, 117, 117); */
  background-clip: border-box;
  border-block-end-color: rgb(117, 117, 117);
  border-block-end-style: none;
  border-block-end-width: 0px;
  border-block-start-color: rgb(117, 117, 117);
  border-block-start-style: none;
  border-block-start-width: 0px;
  border-bottom-color: rgb(117, 117, 117);
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-bottom-style: none;
  border-bottom-width: 0px;
  border-collapse: separate;
  border-image-outset: 0;
  border-image-repeat: stretch;
  border-image-slice: 100%;
  border-image-source: none;
  border-image-width: 1;
  border-inline-end-color: rgb(117, 117, 117);
  border-inline-end-style: none;
  border-inline-end-width: 0px;
  border-inline-start-color: rgb(117, 117, 117);
  border-inline-start-style: none;
  border-inline-start-width: 0px;
  border-left-color: rgb(117, 117, 117);
  border-left-style: none;
  border-left-width: 0px;
  border-right-color: rgb(117, 117, 117);
  border-right-style: none;
  border-right-width: 0px;
  border-top-color: rgb(117, 117, 117);
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-top-style: none;
  border-top-width: 0px;
  border: 1px solid #e0e0e0;
}
.tracklist-header {
  display: flex;
}
.yqcr-ps {
  position: relative;
  width: 25%;
  min-width: 220px;
  max-width: 240px;
  -webkit-box-flex: 0;
  -moz-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
}
.yqcr-transit-mid {
  position: relative;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  width: 10%;
  min-width: 150px;
  max-width: 190px;
  -webkit-box-flex: 0;
  -moz-box-flex: 0;
  -ms-flex: 0 0 auto;
  flex: 0 0 auto;
}
.yqcr-last-event-pc {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  padding: 10px;
  cursor: pointer;
  -webkit-box-pack: left;
  -webkit-justify-content: left;
  -ms-flex-pack: left;
  justify-content: left;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.out_border_singed {
  border: #4a42bb solid 1px;
  background: #ffffff;
}
.out_border_unsinged {
  border: #bd7878 solid 1px;
  background: #ffffff;
}
.fade-enter-active {
  transition: height 1.8s;
}
.fade-enter {
  height: 0;
}
.message-text {
  font-family: MicrosoftYaHei;
  font-size: small;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3rem;
  letter-spacing: 0rem;
  color: #333333;
  width: 50%;
}
.fontblack {
  color: #999999;
}
.img2 {
  width: 0.81rem;
  height: 0.8rem;
  float: right;
}
.addressshow2 {
  height: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  width: 75%;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
  font-size: small;
}
.addressshow1 {
  height: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  width: 75%;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
  font-size: small;
}
.orderTitle {
  font-size: small;
  color: #333333;
  height: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
  height: 2.5rem;
}
.orderDetail {
  font-size: 0.8rem;
  color: #666666;
  text-align: left;
}
.border-ceter {
  width: 92%;
  padding-left: 15px;
  padding-right: 15px;
}
.pay-button {
  width: 88%;
  height: 2.6rem;
  position: relative;
  background-color: red;
  color: white;

  margin-left: 6%;
}
ul li {
  list-style: none;
  font-size: small;
}
ul {
  padding-left: 1.5rem;
}
.track-rcol {
}
.track-list {
  position: relative;
}
.track-list li {
  position: relative;
  padding: 0px 0 1rem 25px;
  line-height: 1rem;
  text-align: left;
  border-left: 1px solid #d9d9d9;
  color: #999;
}
.track-list li.first {
  color: red;
  padding-top: 0;
  width: 100%;
  text-align: left;
  border-left: 1px solid #d9d9d9;
}
.track-list li .node-icon {
  position: absolute;
  left: -3px;
  border-radius: 0.25rem;
  width: 0.5rem;
  height: 0.5rem;
  top: 4px;
  background-color: #999999;
}
.track-list li.first .node-icon {
  background-position: 0-72px;
  width: 1rem;
  z-index: 2;
  height: 1rem;
  position: absolute;
  left: -5px;
  top: 0;
  border-radius: 0.5rem;
  color: rgb(124, 114, 114);
}
.track-list li .time {
  margin-right: 20px;
  position: relative;
  top: 4px;
  display: inline-block;
  vertical-align: middle;
  background-color: white;
  color: #999;
  width: 100%;
  text-align: left;
}
.track-list li .txt {
  position: relative;
  display: inline-block;
  vertical-align: top;
  text-align: left;
  font-size: small;
  color: rgb(124, 114, 114);
}
.track-list li.first .time {
  text-align: left;
  width: 94%;
  color: rgb(31, 27, 27);
}
.track-list li.first .txt {
  text-align: left;
  width: 94%;
  color: rgb(31, 27, 27);
}
.track-list li.finall {
  position: relative;
  padding: 0px 0 1.5rem 25px;
  line-height: 18px;
  border-color: white;
  border-left: 1px solid #ffffff;
  text-align: left;
  color: #999;
}
.track-list li.finall .div-spilander {
  width: 1px;
  position: absolute;
  position: absolute;
  left: -1.5px;
  height: 0.5rem;
  background-color: #d9d9d9;
}
</style>
